import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

export default function SimpleSelect(props) {
  const classes = useStyles();
  const [age, setAge] = React.useState('0');

  const handleChange = (event) => {
    setAge(event.target.value);
    props.onTypeChange(event.target.value)
  };

  return (
    <div>
      <FormControl className="reminderselect">
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={age}
          onChange={handleChange}
        >
          <MenuItem value={0}>Please Select</MenuItem>
          <MenuItem value={1}>App Notification</MenuItem>
          <MenuItem value={2}>WhatsApp</MenuItem>
          {/* <MenuItem value={3}>SMS</MenuItem>
          <MenuItem value={4}>Telegram</MenuItem>
          <MenuItem value={5}>Call</MenuItem>
          <MenuItem value={6}>None</MenuItem> */}
        </Select>
      </FormControl>
    
    </div>
  );
}
